<script lang="ts">
import { useDesignStore } from '@/stores/designStore.ts'
import { BFormInput } from 'bootstrap-vue-next'
import { ModelRef, Ref, defineModel, ref, watch } from 'vue'
export default {
  props: ['value'],
  emits: ['newValue'],
  setup(props, context) {
    const designStore = useDesignStore()
    const searchValue = ref(props.value)
    function newValue(value) {
      context.emit('newValue', value)
    }
    watch(props, async (props, old) => {
      searchValue.value = props.value
    })
    return {
      newValue,
      designStore,
      searchValue,
      context
    }
  },
  components: { BFormInput }
}
</script>
<template>
  <div
    style="border-radius: 0; border: none; border-bottom: 2px solid; display: flex"
    :style="{
      fontFamily: designStore.font,
      color: designStore.inputText,
      background: designStore.inputBacking,
      borderColor: designStore.secondaryTheme,
      '--bs-secondary-color': designStore.inputText
    }"
  >
    <i
      style="align-self: center; padding: 0.35rem 0.55rem 0.35rem 0.55rem; font-size: large"
      :style="{ background: designStore.primaryTheme, color: designStore.primaryText }"
      class="bi bi-search"
    ></i>
    <BFormInput
      @keydown.enter="newValue(searchValue)"
      placeholder="Search..."
      v-model="searchValue"
      style="border-radius: 0; border: none; border-left: 2px solid"
      :style="{
        fontFamily: designStore.font,
        color: designStore.inputText,
        background: designStore.inputBacking,
        borderColor: designStore.secondaryTheme,
        '--bs-secondary-color': designStore.inputText
      }"
      class="inputSearch"
      debounce="200"
      @update:model-value="newValue(searchValue)"
    />
  </div>
</template>
